import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { LazyLoadEvent } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { LimSimDataService } from '../../data-services/limsim.service';
import { DialogService } from 'primeng/dynamicdialog';
import { DomSanitizer } from '@angular/platform-browser';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'limsim-requisition-list',
  templateUrl: './limsim.list.html',
  providers: [DialogService, MessageService],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ height: 0, opacity: 0.5 }),
            animate('0.5s ease-out',
              style({ height: '*', opacity: 1 }))
          ]
        ),
        transition(
          ':leave',
          [
            style({ height: '*', opacity: 1 }),
            animate('0.5s ease-in',
              style({ height: 0, opacity: 0.5 }))
          ]
        )
      ]
    )
  ],
  imports: [Toast, CommonModule, TableModule]
})
export class LimSimListComponent implements OnInit {

  constructor(private limSimService: LimSimDataService,
    public dialogService: DialogService,
    private router: Router) {
    this.queryParams = this.router.routerState.snapshot.root.queryParams["includeExceptions"];
  }

  listData;
  totalRecords: number;
  cols: any[];
  loading: boolean;
  queryParams: string;
  sub: any;

  ngOnInit() {


    this.cols = [
      { field: 'Accession', header: 'SID' },
      { field: 'Status', header: 'Status' },
      { field: 'LabPanelName', header: 'Ordered Panel' },
      { field: 'LabTestName', header: 'TestName' },
      { field: 'LastName', header: 'Last Name' },
      { field: 'FirstName', header: 'First Name' },
      { field: 'FacilityCode', header: 'Facility' },
    ];
    this.loading = true;
  }

  public handleSearchKey(event, reqlist) {
    if (event.keyCode == 13) {
      reqlist.filterGlobal(event.target.value, 'contains');
      event.preventDefault();
    }
  }

  lastLoad: LazyLoadEvent;
  public loadListLazy(event: LazyLoadEvent) {
    this.loading = true;
    if (event) {
      this.lastLoad = event;
    } else {
      this.lastLoad.first = 0;
      event = this.lastLoad;
    }
    this.limSimService.getList(event.first, event.rows, event.sortField, event.sortOrder, event.filters).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.listData = data.rows;

      event.filters.global = {};
      this.loading = false;
    });
  }

}
